import useManageRecentSearches from '@hooks/search/use-manage-recent-searches';

const ManageRecentSearches = () => {
  useManageRecentSearches();
  return null;
};

export default ManageRecentSearches;
